import { Navigate, useLocation, type Location } from "react-router";
import { BUYER, BUYERS, LEGACY_RETAILER } from "../constants/routes";
import { useRouteParams } from "../hooks/useRouteParams";

const appendLocationSuffix = (pathname: string, location: Location) =>
  `${pathname}${location.search}${location.hash}`;

/** Redirects bookmarked retailer URLs to their buyer equivalents. */
export const LegacyBuyersListRedirect = () => {
  const location = useLocation();

  return (
    <Navigate to={appendLocationSuffix(BUYERS, location)} replace={true} />
  );
};

export const LegacyBuyerRedirect = () => {
  const location = useLocation();
  const { retailerId } = useRouteParams(LEGACY_RETAILER) ?? {};

  return retailerId ? (
    <Navigate
      to={appendLocationSuffix(
        BUYER.href({ buyerId: Number(retailerId) }),
        location,
      )}
      replace={true}
    />
  ) : (
    <Navigate to={appendLocationSuffix(BUYERS, location)} replace={true} />
  );
};
